// Only for use with our webpack library build as a workaround to keep simple webpack config. Do not import into other JS files. Please use android_errors.js

module.exports = require('./errors').default;